var _a;
import { createSlice } from '@reduxjs/toolkit';
import { t } from '../../strings/i18n/i18n';
import { ModalType } from './typings';
export var initialState = {
    formError: '',
    modalType: ModalType.DisputeDetail,
    isLoading: false,
    additionalFieldFormError: ''
};
/*
 * Removed feature flag actions from the ui loading logic as we don't want that call
 * controlling the global loading animations
 */
var isFulfilledAction = function (action) {
    return (action.type.endsWith('fulfilled') && !action.type.startsWith('featureFlags'));
};
var isPendingAction = function (action) {
    return (action.type.endsWith('pending') && !action.type.startsWith('featureFlags'));
};
var isRejectedAction = function (action) {
    return (action.type.endsWith('rejected') && !action.type.startsWith('featureFlags'));
};
var uiStateSlice = createSlice({
    name: 'uiState',
    initialState: initialState,
    reducers: {
        openModal: function (state, action) {
            state.modalType = action.payload;
        },
        closeModal: function (state) {
            /*
             * NOTE: reset to default, practically DisputeDetail means no modal
             */
            state.modalType = ModalType.DisputeDetail;
        },
        updateLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        updateFormError: function (state, action) {
            var _a = action.payload, payload = _a === void 0 ? t('formError.pleaseSelect') : _a;
            state.formError = payload;
        },
        updateAdditionalFieldFormError: function (state, action) {
            var _a = action.payload, payload = _a === void 0 ? t('formError.pleaseAnswer') : _a;
            state.additionalFieldFormError = payload;
        },
        clearFormError: function (state) {
            state.formError = '';
            state.additionalFieldFormError = '';
        },
        clearUiState: function () {
            return initialState;
        }
    },
    extraReducers: function (builder) {
        builder.addMatcher(isPendingAction, function (state) {
            state.isLoading = true;
        });
        builder.addMatcher(isFulfilledAction, function (state) {
            state.isLoading = false;
        });
        builder.addMatcher(isRejectedAction, function (state) {
            state.isLoading = false;
        });
    }
});
export var openModal = (_a = uiStateSlice.actions, _a.openModal), closeModal = _a.closeModal, updateLoading = _a.updateLoading, updateFormError = _a.updateFormError, updateAdditionalFieldFormError = _a.updateAdditionalFieldFormError, clearFormError = _a.clearFormError, clearUiState = _a.clearUiState;
export default uiStateSlice.reducer;
//# sourceMappingURL=ui.slice.js.map